import { useContext } from "react";

// components
import Spinner from "../../../components/spinner/Spinner";
import Input from "../../../components/input/Input";
import Button from "../../../components/button/Button";

// context
import { userContext } from "../../../context/user-provider/UserProvider";
import { currencyContext } from "../../../context/currency-provider/CurrencyProvider";

// hooks
import { useCreateBalanceForm } from "./use-balance";
import { useProfileAdminFetch } from "../profile-screen/use-profile";

// styles
import styles from "./BalanceScreen.module.scss";

export function BalanceScreen() {
  const { userData } = useContext(userContext);
  const { getCurrency } = useContext(currencyContext);

  const {
    balanceFormData,
    isDisabledSubmitButton,
    handleChangeBalanceData,
    onSubmit,
  } = useCreateBalanceForm();
  const { isProfileLoading } = useProfileAdminFetch();

  return (
    <form className={styles.balanceSection}>
      {isProfileLoading ? (
        <Spinner />
      ) : (
        <>
          <div className={styles.balanceWrapper}>
            <div className={styles.balanceInfo}>
              <p>Current balance</p>
              <h6>
                {userData?.balance} {getCurrency()}
              </h6>
            </div>

            <p className={styles.notification}>
              The minimum amount to deposit is 5 EUR
            </p>
          </div>

          <div className={styles.inputWrapper}>
            <Input
              variant="admin"
              type="number"
              placeholder="Enter the amount to top up"
              value={balanceFormData}
              onChange={handleChangeBalanceData}
              validation={{
                error:
                  balanceFormData && Number(balanceFormData) < 5 ? true : false,
                message:
                  balanceFormData && Number(balanceFormData) < 5
                    ? "The minimum amount for a deposit is 5 EUR"
                    : "",
              }}
            />
            <Button
              width="auto"
              disabled={isDisabledSubmitButton}
              onClick={(e) => onSubmit(e)}
            >
              Top Up
            </Button>
          </div>
        </>
      )}
    </form>
  );
}
